export default {"src":"/_next/static/media/eyeOpen.bfb59995.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};